import React, { useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { template } from '@yola/ws-sdk';
import site from 'yola-editor/src/js/modules/site';
import segment from 'src/js/modules/analytics/segment';
import MainMenu from 'src/js/modules/common/components/main-menu';
import sortMenuItems from 'src/js/modules/help-menu/helpers/sort-menu-items';
import useMatchBreakpoint from 'src/js/modules/utils/custom-hooks/use-match-breakpoint';
import iconTypes from 'src/js/modules/common/constants/menu-item-icon-types';
import getDesignMenuItems from '../../website-design/helpers/get-design-menu-items';
import getDesignMenuItemClickCallbacks from '../../website-design/helpers/get-design-menu-item-click-callbacks';
import dialogCallSourceIds from '../../website-design/constants/dialog-call-source-ids';

const { UP, DOWN } = iconTypes;

const {
  track,
  constants: { events },
} = segment;

const DESKTOP_VIEW_BREAKPOINT = '768px';

function WebsiteDesignTrigger() {
  const isDesktopView = useMatchBreakpoint(DESKTOP_VIEW_BREAKPOINT);

  const [isOpen, setIsOpen] = useState(false);
  const iconGlyph = isOpen ? UP : DOWN;

  const { id: siteId } = useSelector(site.selectors.getSiteData);
  const templateBuildSlug = template.accessors.getBuildSlug();

  const designMenuItemClickCallbacks = getDesignMenuItemClickCallbacks(
    dialogCallSourceIds.EDITOR_HEADER
  );

  const designMenuItems = getDesignMenuItems(designMenuItemClickCallbacks);

  const { submenu, heading } = designMenuItems;

  const designMenuOnShowHandler = () => {
    setIsOpen(true);

    track(events.DESIGN_SETTINGS_TRIGGER_CLICKED, {
      siteId,
      templateBuildSlug,
    });
  };

  const designMenuOnHideHandler = () => {
    setIsOpen(false);
  };

  const sortedMenuItems = useMemo(() => sortMenuItems(submenu), [submenu]);

  const captions = { name: heading };

  return (
    <MainMenu
      onShow={designMenuOnShowHandler}
      onHide={designMenuOnHideHandler}
      captions={captions}
      className="ws-mainmenu--design-menu"
      iconGlyph={iconGlyph}
      items={sortedMenuItems}
      showDetails={false}
      isHidden={!isDesktopView}
    />
  );
}

export default WebsiteDesignTrigger;
